import request from '@/util/http';

export default {
  list,         //文章列表
  addDjArt,     //添加顶级文章
  deletead,     //删除文章
  addorupdatead,//发布文章
}

function list(data) {
  return request({
    url: "sys/api/adlist",
    method: 'post',
    data
  })
}

function addDjArt(data) {
  return request({
    url: "sys/api/addorupdatead",
    method: 'post',
    data
  })
}

function deletead(data) {
  return request({
    url: "sys/api/deletead",
    method: 'post',
    data
  })
}

function addorupdatead(data) {
  return request({
    url: "sys/api/addorupdatead",
    method: 'post',
    data
  })
}